import { Row, Col, Form } from "react-bootstrap";

const FiguraOperadorFormFields = ({ formik }) => {
  const { values, errors, touched, handleChange, setFieldValue } = formik;

  return (
    <div className="mb-4 border p-3 rounded">
      <Row className="mb-3">
        {/* Tipo de figura */}
        <Form.Group as={Col} md="4" controlId="TipoFigura">
          <Form.Label>Tipo de figura</Form.Label>
          <Form.Select
            name="TipoFigura"
            value={values.TipoFigura}
            onChange={(e) => {
              const selected = e.target.value;
              const descriptions = {
                "01": "Operador",
                "02": "Propietario",
                "03": "Arrendador",
                "04": "Notificado",
                "05": "Integrante de Coordinados",
              };
              setFieldValue("TipoFigura", selected);
            }}
            isInvalid={touched.TipoFigura && !!errors.TipoFigura}
          >
            <option value="">Seleccione una opción</option>
            <option value="01">01 - Operador</option>
            <option value="02">02 - Propietario</option>
            <option value="03">03 - Arrendador</option>
            <option value="04">04 - Notificado</option>
            <option value="05">05 - Integrante de Coordinados</option>
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.TipoFigura}
          </Form.Control.Feedback>
        </Form.Group>

        {/* Nombre */}
        <Form.Group as={Col} md="4" controlId="NombreFigura">
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type="text"
            name="NombreFigura"
            placeholder="Nombre del operador"
            value={values.NombreFigura}
            onChange={handleChange}
            isInvalid={touched.NombreFigura && !!errors.NombreFigura}
          />
          <Form.Control.Feedback type="invalid">
            {errors.NombreFigura}
          </Form.Control.Feedback>
        </Form.Group>

        {/* RFC */}
        <Form.Group as={Col} md="4" controlId="RFCFigura">
          <Form.Label>RFC</Form.Label>
          <Form.Control
            type="text"
            name="RFCFigura"
            placeholder="RFC"
            value={values.RFCFigura}
            onChange={handleChange}
            isInvalid={touched.RFCFigura && !!errors.RFCFigura}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors.RFCFigura}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Licencia */}
      <Row className="mb-3">
        <Form.Group as={Col} md="4" controlId="NumLicencia">
          <Form.Label>No. de licencia</Form.Label>
          <Form.Control
            type="text"
            name="NumLicencia"
            placeholder="Número de licencia"
            value={values.NumLicencia}
            onChange={handleChange}
            isInvalid={touched.NumLicencia && !!errors.NumLicencia}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors.NumLicencia}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </div>
  );
};

export default FiguraOperadorFormFields;
